module.exports = __webpack_public_path__ + "static/img/letho.e1fafc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/letho.png
// module id = oms9
// module chunks = 0